const emitir_ficha_individual_por_turma = [
  {
    path: "/emitir-ficha-individual-por-turma",
    name: "emitir_ficha_individual_por_turma",
    meta: {
      allowedPermissions: ["atasfinais_ficha_individual_turma_pdf"],
      breadCrumb: "Processo de Resultado Final - Encerramento do Ano Letivo",
    },
    component: () =>
      import(
        "@/views/EmitirFichaIndividualPorTurma/EmitirFichaIndividualPorTurma.vue"
      ),
  },
];

export { emitir_ficha_individual_por_turma };
